import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Party } from '../party.model';
import {TableLazyLoadEvent, Table} from "primeng/table";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';

@Component({
    selector: 'app-party-table',
    templateUrl: './party-table.component.html',
    styleUrls: ['./party-table.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        TableModule,
        AvatarModule,
        ButtonModule,
        TooltipModule,
        TagModule
    ]
})
export class PartyTableComponent {
    @Input() parties: Party[] = [];
    @Input() totalRecords = 0;
    @Input() isLoading = false;
    @Input() emptyMessage = 'No records found.';
    @Input() icon = 'pi pi-building';
    @Input() resolveViewLink: ((party: Party) => Array<string | number> | null) | null = null;

    @Output() lazyLoad = new EventEmitter<TableLazyLoadEvent>();
    @Output() edit = new EventEmitter<Party>();

    @ViewChild('dt') dt: Table | undefined;

    onLazyLoad(event: TableLazyLoadEvent): void {
        this.lazyLoad.emit(event);
    }

    onEdit(party: Party): void {
        this.edit.emit(party);
    }

    getViewLink(party: Party): Array<string | number> | null {
        return this.resolveViewLink?.(party) ?? null;
    }

    filterGlobal(value: string, matchMode: string): void {
        this.dt?.filterGlobal(value, matchMode);
    }

    reset(): void {
        this.dt?.reset();
    }
}
